<template>
<div class="row loading-wrapper">
  <div class="loading">
    <img src="/logo-circle.svg" />
  </div>
</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>

.loading-wrapper {
  position: relative;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  display: flex;
  text-align: center;
  display: block;
  position: relative;
  // background: #edeff2;
}

.loading-wrapper:hover {
  background: transparent;
}

.loading {
  position: relative;
  margin: auto;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;  
  padding: 25px 0;
  width: 100%;
}

.loading::before {
  content: "";
  position: relative;
  inset: -55px;
  background: url("/logo-circle.svg");
  background-size: cover;
  border-radius: 50%;
  opacity: 0.5;
  animation: pulseInline 3s infinite;
  animation-fill-mode: forwards;
  animation-direction: alternate;
  transition: 1s linear;
  z-index: -1;
}

.loading img {
  opacity: .45;
  width: 76px;
  box-shadow: 0 0 10px #ddd;
  border-radius: 50%;
  border: 5px solid #ddd;
  animation: pulse 3s forwards infinite;
  animation-fill-mode: forwards;
  animation-direction: alternate;
  display: block;
  z-index: 99;
}

@keyframes pulse {
  0% {
    border-color: transparent;
    box-shadow: 0 0 10px #ddd;
    transform: scale(1);
  }

  25% {
    border-color: #ddd;
    box-shadow: 0 0 100px #fff;
    transform: scale(1.05);
  }

  50% {
    border-color: #ddd;
    box-shadow: 0 0 100px #fff;
    transform: scale(1.1);
  }

  100% {
    border-color: #ddd;
    box-shadow: 0 0 100px #fff;
    transform: scale(1);
  }
}

@keyframes pulseInline {
  0% {
    transform: rotate(0deg);
    filter: blur(0px);
  }

  /* 25% {
                transform: rotate(90deg);
                filter: blur(2.5px)
            }

            50% {
                transform: rotate(180deg);
                filter: blur(5px)
            } */

  100% {
    transform: rotate(360deg);
    filter: blur(0);
  }
}
</style>
